const standardTheme = {
  name: "selfpoint3",
  componentsMarginBottom: "24px",
  colors: {
    background: "#f5f5f5",
    surface: "#ffffff",
    primary: "#404e67",
    primaryVariant: "#d6e5f2",
    secondary: "orange",
    secondaryVariant: "#009375",
    component: "#ffffff",
    danger: "#f8d7da",
    warning: "#fff3cd",
    success: "#d4edda",
    info: "#d1ecf1",
    disabled: "rgb(204,204,204)",
    on: {
      background: "#333333",
      surface: "#333333",
      primary: "#f5f5f5",
      primaryVariant: "#333333",
      secondary: "#f5f5f5",
      secondaryVariant: "#f5f5f5",
      component: "#333333",
      danger: "#721c24",
      warning: "#856404",
      success: "#155724",
      info: "#0c5460",
      disabled: "rgb(134,134,134)",
    },
    border: {
      background: "#eeeeee",
      surface: "#ccc",
      primary: "#006699",
      primaryVariant: "#d6e5f2",
      secondary: "#00a483",
      secondaryVariant: "#009375",
      component: "#dddddd",
      danger: "#f5c6cb",
      critical: "#f5c6cb",
      warning: "#ffeeba",
      success: "#c3e6cb",
      info: "#bee5eb",
      disabled: "rgb(204,204,204)",
    },
    text: {
      danger: "#dc3545",
      warning: "#ffc107",
      success: "#28a745",
      info: "#17a2b8",
      disabled: "#E0E0E0",
    },
  },
  altColors: {
    primary: "white",
    secondary: "#fff",
    third: "white",
    success: "#28a745",
    danger: "#721c24",
    info: "white",
    warning: "#856404",
    border: "#ccc",
    hoverBackground: "lightgrey",
    font: "black",
  },
  borders: {
    primary: "#ccc",
    success: "green",
    danger: "#f5c6cb",
    warning: "#ffeeba",
    info: "#b8daff",
  },
  backgrounds: {
    primary: "#404e67",
    secondary: "orange",
    controlBar: "#ccc",
    info: "#cce5ff",
    success: "green",
    danger: "#f8d7da",
    warning: "#fff3cd",
    workspace: "#fefefe",
  },
  fonts: {
    primary: "Nunito",
    secondary: "Nunito",
  },
  breakpoints: {
    sm: "(min-width: 576px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 992px)",
    xl: "(min-width: 1200px)",
  },
  hover: {
    colors: {
      danger: "red",
      info: "white",
    },
    backgrounds: {
      info: "#cce500",
    },
  },
  background: {
    nav: "#404e67",
    primary: "white",
    secondary: "orange",
    info: "#cce5ff",
    success: "green",
    danger: "#f8d7da",
    critical: "#f8d7da",
    warning: "#fff3cd",
  },
  color: {
    nav: "white",
    navSelected: "orange",
    primary: "#404e67",
    secondary: "orange",
    info: "#cce5ff",
    success: "green",
    danger: "#f8d7da",
    critical: "#f8d7da",
    warning: "#fff3cd",
  },
  altColor: {
    navSelected: "orange",
    primary: "#404e67",
    secondary: "orange",
    info: "#004085",
    success: "green",
    danger: "#721c24",
    critical: "#721c24",
    warning: "#856404",
  },
  border: {
    primary: "#ccc",
    success: "green",
    danger: "#f5c6cb",
    warning: "#ffeeba",
    critical: "#f5c6cb",
    info: "#b8daff",
  },
  font: {
    primary: "Nunito",
    secondary: "Nunito",
  },
  nav: {
    background: "#404e67",
    color: "white",
    active: {
      color: "orange",
    },
    category: {
      color: "orange",
    },
  },
  header: {
    background: "#404e67",
    color: "white",
    active: {
      color: "orange",
    },
    category: {
      color: "orange",
    },
  },
  section: {
    background: "white",
  },
  panel: {
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxShadow: "0px 3px 15px rgba(0, 0, 0, 0.02)",
  },
  button: {
    primary: "#006699",
    secondary: "#6c757d",
    on: {
      primary: "white",
      secondary: "black",
    },
  },
};

export default standardTheme;
